import {lazy} from 'react';

const DocumentList = lazy(() => import('./DocumentList'));
const DocumentDetails = lazy(() => import('./DocumentDetails'));

export const DocumentManagerConfig = [
  {
    path: '/document-manager/document-list',
    element: <DocumentList />,
  },
  {
    path: '/document-manager/details/:id',
    element: <DocumentDetails />,
  },
];
